<template>

<section class="kc-elm kc-css-543844 kc_row slmm-mobile-hide">
<div class="map-section-map">
   <div class="map-section-bg"></div>
   <h2 class="section-header">{{$t('footer.box2_title')}} <span class="text-white">{{$t('footer.box22_title')}}</span></h2>
   <div class="location-usa">
      <div class="our-location location-usa-dc wow animated bounceInDown" data-wow-duration="2s" data-wow-delay="0s">
         <div class="our-location-text">
            <div class="our-location-text-time">UTC-5</div>
            <h5>WASHINGTON DC <span>USA</span></h5>
         </div>
         <div class="our-location-more"></div>
      </div>
      <div class="our-location location-usa-miami wow animated bounceInDown" data-wow-duration="2s" data-wow-delay="0s">
         <div class="our-location-text">
            <div class="our-location-text-time">UTC-5</div>
            <h5>MIAMI <span>USA</span></h5>
         </div>
         <div class="our-location-more"></div>
      </div>
   </div>
   <div class="location-mex wow animated bounceInDown" data-wow-duration="2s" data-wow-delay="0s">
      <div class="our-location location-mex-mexico">
         <div class="our-location-text">
            <div class="our-location-text-time">UTC-6</div>
            <h5>MEXICO CITY <span>MEXICO</span></h5>
         </div>
         <div class="our-location-more"></div>
      </div>
   </div>
   <!-- <div class="location-colombia">
      <div class="our-location location-mex-mexico">
         <div class="our-location-text">
            <div class="our-location-text-time">UTC-5</div>
            <h5>BOGOTA<span>Colombia</span></h5>
         </div>
         <div class="our-location-more"></div>
      </div>
   </div> -->
   <div class="our-location location-arg wow animated bounceInDown" data-wow-duration="2s" data-wow-delay="0s">
      <div class="our-location-text">
         <div class="our-location-text-time">UTC-3</div>
         <h5>BUENOS AIRES <span>Argentina</span></h5>
      </div>
      <div class="our-location-more">
         <!-- <a href="#" target="_blank">learn more</a> -->
      </div>
   </div>
   <!-- <div class="location-ua">
      <div class="our-location location-ua-kyiv">
         <div class="our-location-text">
            <div class="our-location-text-time">UTC+2</div>
            <h5>KYIV <span>Ukraine</span></h5>
         </div>
         <div class="our-location-more"></div>
      </div>
      <div class="our-location location-ua-kharkiv">
         <div class="our-location-text">
            <div class="our-location-text-time">UTC+2</div>
            <h5>KHARKIV <span>Ukraine</span></h5>
         </div>
         <div class="our-location-more"></div>
      </div>
      <div class="our-location location-ua-odesa">
         <div class="our-location-text">
            <div class="our-location-text-time">UTC+2</div>
            <h5>ODESA <span>Ukraine</span></h5>
         </div>
         <div class="our-location-more"></div>
      </div>
   </div> -->
</div>
</section>

</template>

<script>
export default {
  name: "Locations",
  props: ["title", "subtitle", "header"],
  data() {
    return {
      msg: "Locations"
    };
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

@media screen and (max-width: 999px) {
    .slmm-mobile-hide {
        display: none !important;
    }
}

.kc-css-543844{
  padding: 0 10% 0 10%;
  background-color: #121212;
}
.section-header{
  position: absolute;
  top: 4px;
  color: #ED7D31;
  margin: 0;
  font-weight: 600;
}
.map-section-map{position:relative;padding-top:62%;}
.map-section-bg{background:url(../../assets/images/map.png);background-repeat:no-repeat;background-position-x:-188px;padding:0;background-size:cover;background-color:#2b2b2b;position:absolute;top:0;left:0;right:0;bottom:0;}
.our-location{display:inline-block;position:absolute;}
.our-location-text-time{font-family:'Montserrat Regular';font-style:normal;font-weight:700;line-height:18px;font-size:12px;letter-spacing:.02em;color:#fff;padding:4px 0 6px;}
.our-location-text h5{font-family:'Montserrat Regular';font-style:normal;font-weight:800;line-height:21px;font-size:14px;letter-spacing:.02em;color:#ED7D31;margin:0;}
.our-location-text h5 span{padding-left:30px;line-height:14px;font-size:9px;text-align:right;letter-spacing:.02em;color:#bcbcbc;}
.our-location-more{font-family:'Montserrat Regular';font-style:normal;font-weight:300;line-height:20px;font-size:13px;letter-spacing:.02em;color:#ea9201;text-align:right;padding-top:5px;}
.our-location-more a:hover{color:#fff;}

.location-usa-miami{left:-4%;top:37%;}
.location-usa .our-location-text{background-image:url(../../assets/images/loc-line-r.png),url(../../assets/images/loc-bottom.png);background-repeat:no-repeat;background-position-x:right,left;background-position-y:bottom;padding:15px 0 5px 120px;transition:all .5s ease-in-out;}
.location-usa .our-location-text:after{background-image:url(../../assets/images/loc-line-r.png),url(../../assets/images/loc-bottom-h.png);background-repeat:no-repeat;background-position-x:right,left;background-position-y:bottom;transition:all .5s ease-in-out;content:"";position:absolute;bottom:5px;left:0;right:0;height:100%;opacity:0;}

.location-arg .our-location-more{background-image:url(../../assets/images/loc-line-r.png),url(../../assets/images/loc-top.png);background-repeat:no-repeat;background-position-x:right,left;background-position-y:top;transition:all .5s ease-in-out;padding-bottom:70px;position:relative;}
.location-arg .our-location-text{padding-left:120px;}
.location-arg .our-location-more:after{background-image:url(../../assets/images/loc-top-h.png);background-repeat:no-repeat;background-position-x:left;background-position-y:top;transition:all .5s ease-in-out;content:"";position:absolute;top:0;left:0;right:0;height:100%;width:27%;opacity:0;}

.location-mex-mexico .our-location-text{background-image:url(../../assets/images/loc-line-r.png),url(../../assets/images/loc-bottom.png);background-repeat:no-repeat;background-position-x:right,left;background-position-y:bottom;padding:25px 0 5px 80px;transition:all .5s ease-in-out;position:relative;transform:rotateY(180deg);}
.location-mex-mexico .our-location-text-time,.location-mex-mexico h5{transform:rotateY(180deg);}
.location-mex-mexico .our-location-text:after{background-image:url(../../assets/images/loc-line-r.png),url(../../assets/images/loc-bottom-h.png);background-repeat:no-repeat;background-position-x:right,left;background-position-y:bottom;transition:all .5s ease-in-out;content:"";position:absolute;bottom:0;left:0;right:0;height:100%;opacity:0;}
.location-usa-dc:hover .our-location-text:after,.location-usa-miami:hover .our-location-text:after,.location-arg:hover .our-location-more:after,.location-ua-kyiv:hover .our-location-more:after,.location-ua-kharkiv:hover .our-location-more:after,.location-ua-odesa:hover .our-location-text:after,.location-mex-mexico:hover .our-location-text:after{opacity:1;transition:all .5s ease-in-out;}

.location-usa{
  display: inline-block;
  position: absolute;
  height: 180px;
  width: 350px;
  top: 39%;
  left: 20%;
}
.location-arg{
  top: 73.5%;
  left: 25.5%;
}
.location-mex{
  position: absolute;
  top: 46%;
  left: 0%;
  width: 350px;
}


*{margin:0;padding:0;}
@media all and (min-width:320px) and (max-width:768px){
  .wrap .section-header{font-size:30px;line-height:34px;width:fit-content;width:-moz-fit-content;}
  .location-usa{
    top: 31%;
    left: 9%;
  }
  .location-mex{
    top: 42%;
    left: -22%;
  }
  .location-arg{
    top: 66.5%;
    left: 13.5%;
  }
}
@media all and (min-width:768px) and (max-width:1300px){
.wrap .section-header{font-size:40px;line-height:42px;}
  .location-usa{
    top: 35%;
    left: 14%;
  }
  .location-mex{
    top: 42%;
    left: -12%;
  }
  .location-arg{
    top: 66.5%;
    left: 18.5%;
  }
}
@media all and (min-width:1300px) and (max-width:1500px){
.wrap .section-header{font-size:40px;}
.location-usa-miami{top:30%;}
#map-section .section-header{top:50px;}
  .location-usa{
    top: 37%;
    left: 15%;
  }
  .location-mex{
    top: 44%;
    left: -8%;
  }
  .location-arg{
    top: 70.5%;
    left: 20.5%;
  }
}

@media all and (min-width:1500px) and (max-width:1800px){
#map-section .section-header{top:50px;}
  .location-usa{
    top: 37%;
    left: 18%;
  }
  .location-mex{
    top: 44%;
    left: -5%;
  }
  .location-arg{
    top: 72.5%;
    left: 23.5%;
  }
}
@media all and (min-width:1200px) and (max-width:1400px){
.location-usa-miami{top:33%;}
#map-section .section-header{left:6%;}
}
</style>



// WEBPACK FOOTER //
// src/components/Blocks/Locations.vue